export const UPGRADE_TEXT = {
  workouts: {
    icon: 'icon-workouts',
    iconColor: 'teal-dark',
    title: 'Coaching Zone Workouts',
    slug: 'voome-workouts',
    videoId: '5779090549001',
    items: [
      {
        title: 'Workout Videos',
        description: `Work up a sweat and have fun with the best trainers, in the comfort of your own home.`,
      },
      {
        title: 'Express Workouts',
        description: `10-30 min workouts tailored to your fitness level, with timed exercises and expert instruction.`,
      },
      {
        title: 'Tailored to your fitness level',
        description: `You'll find all our workouts totally doable, with a few hidden challenges to keep you on your toes!`,
      },
    ],
  },

  nutrition: {
    icon: 'icon-recipes',
    iconColor: 'green-mid',
    title: 'Coaching Zone Nutrition',
    slug: 'voome-nutrition',
    videoId: '5779089995001',
    items: [
      {
        title: 'Simple, healthy, delicious recipes',
        description: `With over 1000 recipes to choose from, you'll never be short of ideas.`,
      },
      {
        title: 'Meal Plans',
        description: `Creating a meal plan and shopping list for you and your family has never been easier.`,
      },
      {
        title: 'Tailored for you',
        description: `Cooking for one or for the family? Lactose intolerant, vegetarian or gluten free? We've got you covered.`,
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/constants/Upgrade.js